import { Locale } from '@nemuru-eng/js-api-client';
import { useAuth } from '@nemuru-eng/providers';
import { useState } from 'react';

import { ENV_NEMURU_JS_URL } from '@/config/envVars';
import { getFirstPurchaseCountryCurrencyByAgentId } from '@/utils/getFirstPurchaseCountryCurrencyByAgentId';

export const useNemuruJs = () => {
  const { credentials } = useAuth();

  const [loading, setLoading] = useState(false as boolean);

  const loadNemuruJsWithAgent = async (agentId: string, configuration?) => {
    setLoading(true);
    const libraryLoaded = await loadNemuruLibrary();
    if (libraryLoaded) await nemuruInit(agentId, configuration);
    setTimeout(() => {
      setLoading(false);
    }, 50);
  };

  const loadNemuruLibrary = async () => {
    return new Promise((resolve, reject) => {
      // Check if window is accessible
      if (typeof window === 'undefined') {
        reject('Window is not accessible');
        return;
      }
      // @ts-expect-error Property 'Nemuru' does not exist on type Window
      if (document.getElementById('nemuru-js') && window.Nemuru) {
        resolve(true);
        return;
      }
      // Create script tag
      const script = document.createElement('script');
      script.id = 'nemuru-js';
      script.src = ENV_NEMURU_JS_URL;
      script.type = 'text/javascript';
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        reject('Error loading Nemuru.js');
      };
      document.head.appendChild(script);
    });
  };

  const nemuruInit = async (agentId: string, configuration) => {
    // @ts-expect-error: Cannot find name 'Nemuru'.ts(2304)
    await Nemuru.init({
      clientId: agentId,
      configuration: {
        currency: configuration.currency ?? (await getFirstPurchaseCountryCurrencyByAgentId(agentId)),
        decimalSeparator: configuration.decimalSeparator ?? ',', // TODO
        thousandSeparator: configuration.thousandSeparator ?? '.', // TODO
        locale: configuration.locale ?? Locale.ES_ES, // TODO
      },
      onError: (error) => console.log(error),
    });
  };

  const openOrderManagement = (
    loanId: string,
    options: {
      onAction?: (action: 'order_capture_created' | 'order_refund_created') => void;
      onError?: (error: string) => void;
      onClose?: () => void;
    } = {},
  ) => {
    if (!credentials?.accessToken) {
      throw new Error('No access token found');
    }
    // @ts-expect-error: Cannot find name 'Nemuru'.ts(2304)
    Nemuru.orderManagement({
      container: 'nemuru-order-management',
      orderId: loanId,
      accessToken: credentials.accessToken,
      style: {
        branding: 'iberia',
      },
      ...(options.onAction && { onAction: options.onAction }),
      ...(options.onClose && { onClose: options.onClose }),
      ...(options.onError && { onError: options.onError }),
    });
  };

  return { loadNemuruJsWithAgent, openOrderManagement, loadingNemuruJs: loading };
};
